import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';

/** The fine print under the fee guide. Quinn's standard wording; editable per property. */
export function FeeDisclosure() {
  return (
    <section className="flex flex-col gap-3 px-[--gutter] pb-[72px] pt-[70px] max-[767px]:gap-2.5 max-[767px]:pb-8 max-[767px]:pt-4">
      <RichTextContent path="feedisclosure.eyebrow" as="div" className="eyebrow" />
      <RichTextContent
        path="feedisclosure.body"
        as="div"
        className="text-sm leading-[22px] text-[--q-muted] [&_p:last-child]:m-0 [&_p]:mx-0 [&_p]:mb-[1em] [&_p]:mt-0 max-[767px]:text-[13px] max-[767px]:leading-5"
      />
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'FeeDisclosure',
  displayName: 'Fee Disclosure',
  tokens: {
    'feedisclosure.eyebrow': { label: 'Eyebrow', type: 'richtext', defaultValue: '<p>Please read</p>' },
    'feedisclosure.body': {
      label: 'Disclosure',
      type: 'richtext',
      defaultValue:
        '<p>Unless a fee is explicitly identified as refundable, all fees are non-refundable. Standard Security Deposit subject to change based on screening results; total security deposit(s) will not exceed any legal maximum. Resident may be responsible for maintaining insurance pursuant to the Lease. Resident is responsible for damages that exceed ordinary wear and tear. Some items may be taxed under applicable law. This form does not modify the lease. Additional fees may apply in specific situations as detailed in the application and/or lease agreement, which can be requested prior to the application process. All fees are subject to the terms of the application and/or lease. Residents may be responsible for activating and maintaining utility services, including but not limited to electricity, water, gas, and internet, as specified in the lease agreement.</p>',
    },
  },
};

(FeeDisclosure as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default FeeDisclosure;
